import {
    LifeCycleBadge,
    NO_LIFE_CYCLE_DESCRIPTION,
} from '@/ui/components/LifeCycleBadge';
import { lifeCycleFilterOptions } from 'utils/filters';
import type { LifeCycleLineProps } from '../types';

const LifeCycleLine = ({ stage }: LifeCycleLineProps) => {
    const description =
        lifeCycleFilterOptions.find(({ value }) => value === stage)
            ?.description ?? NO_LIFE_CYCLE_DESCRIPTION;
    return (
        <div className="flex items-center gap-2 flex-wrap">
            <LifeCycleBadge stage={stage} />
            {description && (
                <span className="text-xs text-muted-foreground">
                    {description}
                </span>
            )}
        </div>
    );
};

export default LifeCycleLine;
